import { signOut } from 'firebase/auth';
import { auth } from '../../lib/firebase';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const APP_VERSION = '1.0.0';

export default function AboutSettings() {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      toast.success('Signed out successfully');
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
      toast.error('Failed to sign out');
    }
  };

  const handleSendFeedback = () => {
    window.location.href = `mailto:feedback@cultural.com?subject=Feedback for Cultural&body=App Version: ${APP_VERSION}%0D%0A%0D%0A`;
  };

  return (
    <div className="bg-white rounded-card shadow-card border border-border p-6 sm:p-8">
      <h2 className="text-xl sm:text-2xl font-semibold text-text-primary mb-6">About</h2>

      {/* App Version */}
      <div className="mb-6">
        <div className="text-sm font-medium text-text-primary mb-1">App Version</div>
        <div className="text-base text-text-secondary">{APP_VERSION}</div>
      </div>

      {/* Links */}
      <div className="mb-6 space-y-3">
        <a
          href="/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className="block text-sm text-primary hover:underline"
        >
          Privacy Policy
        </a>
        <a
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="block text-sm text-primary hover:underline"
        >
          Terms of Service
        </a>
        <a
          href="/help"
          target="_blank"
          rel="noopener noreferrer"
          className="block text-sm text-primary hover:underline"
        >
          Help Center
        </a>
      </div>

      {/* Send Feedback */}
      <div className="mb-6">
        <button
          onClick={handleSendFeedback}
          className="px-6 py-3 bg-surface text-text-primary rounded-lg font-semibold hover:bg-[#E0E0E0] transition-all flex items-center gap-2"
        >
          <FontAwesomeIcon icon={faEnvelope} />
          <span>Send Feedback</span>
        </button>
      </div>

      {/* Sign Out */}
      <div className="border-t border-border pt-6">
        <button
          onClick={handleSignOut}
          className="w-full px-6 py-3 text-left text-primary hover:bg-primary/10 rounded-lg transition-colors font-semibold flex items-center gap-2"
        >
          <FontAwesomeIcon icon={faRightFromBracket} />
          <span>Sign Out</span>
        </button>
      </div>
    </div>
  );
}

